import styled from "styled-components";

export const FormContainer = styled.div`
	height: 100%;
	display: contents;
	img {
	object-fit: contain;
	width: 100%;
	height: 100%;
	}
	.slt {
		width: 100%;
	}
	.form {
		width: 100%;
		min-height: 200px;
		margin: auto 0;
		display: flex;
	}
	.slt-logo {
		height: auto;
		display: flex;
		flex-direction: column;
		padding: 20px 20px 0px 20px;
	}
	.slt-bg {
		height: auto;
		display: flex;
		flex-direction: column;
		padding: 20px 20px 20px 20px;
	}
	.btn-ctn {
		z-index: 999;
		padding-top: 10px;
	}
	.main-title {
		font-weight: 800;
	}
	.required{
		color: rgb(91 81 81);
	}
	.error {
		.css-13cymwt-control {
			border-color: #ae1515;
		}
		color: #ae1515;
		&.text-area {
			border: 1px solid #ae1515;
			border-radius: 5px;
		}
	}
	.upload-logo-btn {
		height: 10px;
		width: 10px;
		margin: auto 0;
	}
	.cont-delete-icon {
		/* width: 15px;
		height: 15px; */
	}
	.delete-icon-brochure {
		padding: 0px 5px;
		width: 15px;
		height: 15px;
		margin: 0 5px;
	}
	.label-container{
		gap: 10xp;
	}
	.label-title{
		font-weight: 800;
	}
	.label-title-second {
		color: #666666;
	}
`;

export const Div = styled.div`
	.custom-select {
		width: 100%;
		margin: auto;
		width: calc(100% - 20);
	}
`;

export const InputChooseFile = styled.input``;

export const FileBorder = styled.div``;

export const FileLable = styled.label`
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
`;

export const FileName = styled.a``;

export const CurlIcon = styled.div`
	border-radius: 100%;
	background-color: rgb(88 88 91);
	width: 15px !important;
	height: 15px !important;
	font-size: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	color: #fff;
	&:hover {
		background-color: #ccc;
	}
`;
